/**
 * Matches backend deferred pending-Associate employment:
 * intended classification present, active job_classification blank.
 * @see Membership::Employment::RegisteredAssociateClassification.deferred_inbound_row?
 */
export function isDeferredPendingEmployment(employment: {
  intendedJobClassification?: string | null;
  jobClassification?: string | null;
}): boolean {
  return Boolean(employment.intendedJobClassification) && !employment.jobClassification;
}

export function hasDeferredPendingEmployment(
  employments: Array<{
    intendedJobClassification?: string | null;
    jobClassification?: string | null;
  }>
): boolean {
  return employments.some(isDeferredPendingEmployment);
}
